export interface Address {
  street: string;
  streetNumber: string;
  city: string;
  state: string;
  country: string;
  countryCode: string;
  postalCode: string;
}

export interface AddressFormatOptions {
  includeStreet?: boolean;
  includeStreetNumber?: boolean;
  includeCity?: boolean;
  includeState?: boolean;
  includeCountry?: boolean;
  includeCountryCode?: boolean;
  includePostalCode?: boolean;
}

const defaultOptions: AddressFormatOptions = {
  includeStreet: true,
  includeStreetNumber: true,
  includeCity: true,
  includeState: false,
  includeCountry: false,
  includeCountryCode: false,
  includePostalCode: false,
};

export function formatAddress(
  address: Address,
  options: AddressFormatOptions = {}
): string {
  if (!address) {
    return "";
  }

  const mergedOptions = { ...defaultOptions, ...options };
  const parts: string[] = [];

  // Street and number
  if (
    (mergedOptions.includeStreet && address.street) ||
    (mergedOptions.includeStreetNumber && address.streetNumber)
  ) {
    const streetPart = [
      mergedOptions.includeStreet ? address.street : null,
      mergedOptions.includeStreetNumber ? address.streetNumber : null,
    ]
      .filter(Boolean)
      .join(" ");
    if (streetPart) parts.push(streetPart);
  }

  // City and postal code
  if (
    (mergedOptions.includeCity && address.city) ||
    (mergedOptions.includePostalCode && address.postalCode)
  ) {
    const cityPart = [
      mergedOptions.includeCity ? address.city : null,
      mergedOptions.includePostalCode ? `(${address.postalCode})` : null,
    ]
      .filter(Boolean)
      .join(" ");
    if (cityPart) parts.push(cityPart);
  }

  // State
  if (mergedOptions.includeState && address.state) {
    parts.push(address.state);
  }

  // Country
  if (mergedOptions.includeCountry && address.country) {
    parts.push(address.country);
  }

  return parts.join(", ");
}
